module.exports = __webpack_public_path__ + "img/1018.5ba718c9.png";